import { inject, Injectable } from '@angular/core';
import {
  ComparePlanRequest,
  ComparePlanResponse,
} from '../interfaces/business-reserve-compare.model';
import { ApiResponse } from '../interfaces/api-response.model';
import { API_ENDPOINTS } from '../constants/api.constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * 企業方案比較服務
 */
@Injectable({
  providedIn: 'root',
})
export class BusinessReserveCompareService {
  http: HttpClient = inject(HttpClient);

  /**
   * 企業方案比較 CB-030
   * @param request 企業方案比較請求
   */
  getBusinessPlanComparison(
    request: ComparePlanRequest
  ): Observable<ApiResponse<ComparePlanResponse>> {
    return this.http.post<ApiResponse<ComparePlanResponse>>(
      API_ENDPOINTS.COMPARE_PLAN,
      request
    );
  }
}
